import { motion } from "framer-motion";
import { Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSiteImages } from "@/context/SiteImagesContext";
import { useSiteContent } from "@/context/SiteContentContext";
import { APP_REGISTER_URL } from "@/lib/config";

const FEATURES = [
  { titleKey: "feat1_title", descKey: "feat1_desc", imgKey: "irisBlueMacro" },
  { titleKey: "feat2_title", descKey: "feat2_desc", imgKey: "irisGrey" },
  { titleKey: "feat3_title", descKey: "feat3_desc", imgKey: "irisBlue" },
];

export const Features = () => {
  const { img } = useSiteImages();
  const { t } = useSiteContent();
  return (
    <section id="features" className="relative py-28 px-6" data-testid="features-section">
      <div className="max-w-6xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-center"
        >
          {t('features_title')}
        </motion.h2>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.titleKey}
              data-testid={`feature-card-${i}`}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.1 }}
              className="glass rounded-2xl overflow-hidden group hover:border-white/20 transition-colors duration-300"
            >
              <div className="relative h-52 overflow-hidden">
                <img src={img(f.imgKey)} alt={t(f.titleKey)} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>
              <div className="p-7">
                <h3 className="text-xl font-semibold mb-2">{t(f.titleKey)}</h3>
                <p className="text-white/55">{t(f.descKey)}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Button
            data-testid="features-trial-button"
            onClick={() => { window.location.href = APP_REGISTER_URL; }}
            className="rounded-full bg-gradient-to-r from-indigo-500 to-violet-500 hover:from-indigo-400 hover:to-violet-400 text-white px-8 h-12 gap-2 text-base border-0 shadow-[0_8px_30px_rgba(99,102,241,0.35)]"
          >
            <Zap className="h-5 w-5" /> {t('features_cta')}
          </Button>
        </div>
      </div>
    </section>
  );
};
